import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectDecoratedDeliveryOptions } from 'src/redux/deliveryZoneOptions';
import { selectProductDeliveryByEvent } from 'src/redux/selectors';
import { openDeliveryByEventModal } from '../actions';
import { DeliveryEvent } from '../components/DeliveryEvent';
import { selectCheapestDeliveryOptionPrice } from '../selectors';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onTooltipClick: (concatenatedDeliveryOptionsCode: string) =>
    dispatch(openDeliveryByEventModal(concatenatedDeliveryOptionsCode)),
});

const mapStateToProps = (state: ReduxApplicationState) => ({
  deliveryOptions: selectDecoratedDeliveryOptions(state),
  deliveryByEvent: selectProductDeliveryByEvent(state)!,
  isLoading: state.deliveryZoneOptions.isLoading,
  currency: state.userConfiguration.currencyCode || state.product.price.currency,
  cheapestDeliveryOptionPrice: selectCheapestDeliveryOptionPrice(state),
});

export const DeliveryEventContainer = connect(mapStateToProps, mapDispatchToProps)(DeliveryEvent);
